import styled from "@emotion/styled";
import { Box, Button, Grid, Typography } from "@mui/material";


const PageWrapper = styled.div`
    background: ${props=>props.bg? props.bg : '#fff'};
    background-image: url(${props=>props.bgimg? props.bgimg : ''});
    background-position: center;
    background-repeat: no-repeat;
    padding-top: 25px;
    box-shadow: inset 0px 2px 10px 0px #00000042;
`
const GridEx = styled(Grid)`
    min-height: calc( 100vh - 129px );
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: ${props=>props.center? 'center' : 'space-between'};
    
    .tokenommicsVideo{ position: absolute; right: 0; margin-bottom: 20px; }
    video{ margin-top: 10%; }
    .tokenomicsImg{ width: 100%; max-width: 350px; height: auto; }
    .primaryImg{ display: none; }
    .mainImg,.primaryImg{ width: 100%; max-width: 350px; height: auto; }
        

    @media (max-width: 900px){
        min-height: unset;
        
        .tokenommicsVideo{ position: static; margin-bottom: 20px; }
        .mainImg{ display: none; }
        .primaryImg{ display: block; }
        .mainImg, .primaryImg, video{margin: 20px auto 0;}
    }
`
const SocialImg = styled.img`
    width: 100%;
    max-width: 23px;
    height: auto;
    margin: 0 10px;
`
const ButtonEx = styled(Button)`
    background: ${props=>props.bg? props.bg : '#fff'};
    padding: 10px 15px;
    margin: 10px 0 10px 30px;
    color: ${props=>props.c? props.c : '#fff'};
    min-width: 170px;
    border: 2px solid ${props=>props.c? props.c : '#fff'};
    border-radius: 8px;
    font-weight: 800;

    &:hover{
        background: ${props=>props.bg? props.bg+'a6' : '#fff'};
        border-color: ${props=>props.bg? props.bg : '#fff'};
    }
`
const TypographyEx = styled(Typography)`
    font-size: 28px;
    max-width: 800px;
    margin-left: auto;
    
    @media (max-width: 1200px){ font-size: 24px; }

    @media (max-width: 900px){ font-size: 21px; margin-top: 25px; }

    @media (max-width: 600px){ font-size: 20px; }
`
const SocialMeidaBox = styled(Box)`
    display: none;
    text-align: right;
    margin-top: 30px;
    @media (max-width: 600px){ display: block; }

    img{
        filter: drop-shadow(2px 4px 6px black);
    }
`

export { PageWrapper, GridEx, SocialImg, ButtonEx, TypographyEx, SocialMeidaBox }